module.exports = __webpack_public_path__ + "static/img/默认页.b845072.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/默认页.png
// module id = g+1q
// module chunks = 1